<template>
  <b-row>
    <b-col sm="12">
      <b-card header-tag="header" footer-tag="footer">
        <b-row>
          <b-col>
            <h4 id="traffic" class="card-title mb-0">Contenidos</h4>
            <div class="small text-muted">Administración de todos los contenidos para interfaces web</div>
          </b-col>
        </b-row>
      </b-card>

      <b-row>
        <b-col lg="9">
          <b-row>
            <b-col lg="4"> 
              <Widget :configWidget="configWidget" reference="cant_unconfiguredBlocks" :hasAccess="configWidget.elements.cantUnconfiguredBlocks" />
            </b-col>
            <b-col lg="4"> 
              <Widget :configWidget="configWidget" reference="list_unconfiguredSite" :hasAccess="configWidget.elements.listUnconfiguredSite" />
            </b-col>
          </b-row>
        </b-col>  
        <b-col lg="3" md="12" sm="12">

          <b-list-group>
            <b-list-group-item href="#" class="flex-column align-items-start" @click="openSettings()">
              <div class="d-flex w-100 justify-content-between">
                <h5 class="mb-1">Configuraciones</h5>
                <small>
                  <b-icon icon="chevron-double-right" class="h5"></b-icon>
                </small>
              </div>

              <p class="mb-1">
                Configuración general del sitio web
              </p>
            </b-list-group-item>
          </b-list-group> 

          <b-list-group v-if="parameters.havePage">
            <b-list-group-item href="#" class="flex-column align-items-start" @click="openPages()">
              <div class="d-flex w-100 justify-content-between">
                <h5 class="mb-1">Páginas</h5>
                <small>
                  <b-icon icon="chevron-double-right" class="h5"></b-icon>
                </small>
              </div>

              <p class="mb-1">
                Administrar las páginas que se muestran en el sitio web
              </p>
            </b-list-group-item>
          </b-list-group> 

          <b-list-group class="mt-3">
            <b-list-group-item href="#" class="flex-column align-items-start" @click="openTemplate()">
              <div class="d-flex w-100 justify-content-between">
                <h5 class="mb-1">Selector de Plantillas</h5>
                <small>
                  <b-icon icon="chevron-double-right" class="h5"></b-icon>
                </small>
              </div>

              <p class="mb-1">
                Selector de plantillas dinámico para sitio web
              </p>
            </b-list-group-item>
          </b-list-group> 

          <b-list-group v-if="parameters.havePortabilityTemplate">
            <b-list-group-item href="#" class="flex-column align-items-start" @click="openPortabilityTemplate()">
              <div class="d-flex w-100 justify-content-between">
                <h5 class="mb-1">Portabilidad</h5>
                <small>
                  <b-icon icon="chevron-double-right" class="h5"></b-icon>
                </small>
              </div>

              <p class="mb-1">
                Carga y descarga de plantillas
              </p>
            </b-list-group-item>
          </b-list-group>           

          <hr v-if="arr.PHPCustom.length">
          <b-list-group class="mt-2" v-if="arr.PHPCustom.length">
            <b-list-group-item v-for="item in arr.PHPCustom" :key="item.id" href="#" class="flex-column align-items-start" @click="openPHPCustom(item)">
              <div class="d-flex w-100 justify-content-between">
                <h5 class="mb-1">{{item.name}}</h5>
                <small>
                  <b-icon icon="chevron-double-right" class="h5"></b-icon>
                </small>
              </div>

              <p class="mb-1">
                {{item.observations}}
              </p>
            </b-list-group-item>
          </b-list-group>
        </b-col>        
      </b-row>

    </b-col>
  </b-row>
</template>
<script>
  import serviceAPI from './services'
  import Error from '@/handler/error'
  import Session from '@/handler/session'
  import Profiles from '@/config/profiles'
  import Modules from '@/config/modules'
  import Helper from '@/handler/helper'
  import Widget from '@/components/inc/widget/widget'
  import Param from '@/config/parameters'
  import ServicesPHP from '@/components/modules/users/php/staff/services'

  export default {
    components: {
      Widget
    },
    data: () => {
      return {
        access: {
          module_id: Modules.CONTENIDOS,
          profile_id: Profiles.PERSONAL,
          view_reference: 'dashboard',
          elements: {}
        },
        configWidget: {
          module_id: Modules.CONTENIDOS,
          profile_id: Profiles.PERSONAL,
          elements: {             
            cantUnconfiguredBlocks: true,
            infoUnconfiguredSite: true,
          }
        },
        parameters: {
          havePage: Helper.hasParametersAccess(Param.P15),
          havePortabilityTemplate: Helper.hasParametersAccess(Param.P45)
        },           
        primaryColor: '',
        arr: {
          PHPCustom: []
        }        
      }
    },
    created () {
      /* Configurar permisos de vistas y elementos */
      Helper.hasAccessView(this.access)
      /* Fin configuracion */

      /* Configurar permisos de los widgets */      
      this.configWidget.elements.cantUnconfiguredBlocks = Helper.hasAccessWidget(this.configWidget, 'cant_unconfiguredBlocks')
      this.configWidget.elements.listUnconfiguredSite = Helper.hasAccessWidget(this.configWidget, 'list_unconfiguredSite')
      /* Fin configuracion */
    },
    mounted() {
      this.setup()
      this.getPHPCustom()
    }, 
    methods: {
      setup () {        
        if(Session.getSession().settings) {    
          this.primaryColor = Session.getSession().settings.color_primary
                    
          this.createCSS()
        }
      },         
      createCSS() {
        var hoja = document.createElement('style')
        hoja.innerHTML = ""      
        hoja.innerHTML = hoja.innerHTML  + ".list-group-item-action:hover, .list-group-item-action:focus { background-color: " + this.primaryColor + "; }"

        document.body.appendChild(hoja);
      }, 

      openSettings() {
        this.$router.push({ name: 'ContentsSttaffSettings' })
      },
      openPages() {
        this.$router.push({ name: 'ContentsSttaffPages' })
      },
      openPortabilityTemplate() {
        this.$router.push({ name: 'ContentsStaffPortabilityTemplate' })        
      },      
      openTemplate() {
        this.$router.push({ name: 'ContentsStaffTemplate' })        
      },

      getPHPCustom() {
        ServicesPHP.obtenerPHPByModule(Modules.CONTENIDOS)
        .then((response) => {
          this.arr.PHPCustom = response.data       
        })
      },
      openPHPCustom(item) {
        this.$router.push({ name: 'ViewStaffViewPHPCustom', params: {id: item.id} })
      }
    }    
   
  }
</script>

<style>

</style>
